export default __webpack_public_path__ + "c47b4cfc6510424efb088e3e8f6c65d7.webp";